import axios from "axios";
import { baseUrl } from "./baseUrl";

const api = axios.create({
  baseURL: `${baseUrl}/admin/campaign`,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

// Campaign Types API
export const createCampaignType = async (data) => {
  try {
    const res = await api.post("/add-type", data);
    return res.data;
  } catch (error) {
    console.error("Error creating campaign type:", error);
    throw error;
  }
};

export const getAllCampaignTypes = async () => {
  try {
    const res = await api.get("/list-type");
    return res.data;
  } catch (error) {
    console.error("Error fetching campaign types:", error);
    throw error;
  }
};

export const getCampaignTypeById = async (id) => {
  try {
    const res = await api.get(`/view-type/${id}`);
    return res.data;
  } catch (error) {
    console.error("Error fetching campaign type:", error);
    throw error;
  }
};

export const updateCampaignType = async (data) => {
  try {
    const res = await api.put("/update-type", data);
    return res.data;
  } catch (error) {
    console.error("Error updating campaign type:", error);
    throw error;
  }
};

export const deleteCampaignType = async (id) => {
  try {
    const res = await api.delete(`/delete-type/${id}`);
    return res.data;
  } catch (error) {
    console.error("Error deleting campaign type:", error);
    throw error;
  }
};

// Campaign Status API
export const createStatus = async (data) => {
  try {
    const res = await api.post("/add-status", data);
    return res.data;
  } catch (error) {
    console.error("Error creating campaign status:", error);
    throw error;
  }
};

export const getAllStatuses = async () => {
  try {
    const res = await api.get("/list-status");
    return res.data;
  } catch (error) {
    console.error("Error fetching campaign statuses:", error);
    throw error;
  }
};

export const getStatusById = async (id) => {
  try {
    const res = await api.get(`/view-status/${id}`);
    return res.data;
  } catch (error) {
    console.error("Error fetching campaign status:", error);
    throw error;
  }
};

export const updateStatus = async (data) => {
  try {
    const res = await api.put("/update-status", data);
    return res.data;
  } catch (error) {
    console.error("Error updating campaign status:", error);
    throw error;
  }
};

export const deleteStatus = async (id) => {
  try {
    const res = await api.delete(`/delete-status/${id}`);
    return res.data;
  } catch (error) {
    console.error("Error deleting campaign status:", error);
    throw error;
  }
};

// Campaign Pricing Model API
export const createPricingModel = async (data) => {
  try {
    const res = await api.post("/add-pricing-model", data);
    return res.data;
  } catch (error) {
    console.error("Error creating pricing model:", error);
    throw error;
  }
};

export const getAllPricingModels = async () => {
  try {
    const res = await api.get("/list-pricing-model");
    return res.data;
  } catch (error) {
    console.error("Error fetching pricing models:", error);
    throw error;
  }
};

export const getPricingModelById = async (id) => {
  try {
    const res = await api.get(`/view-pricing-model/${id}`);
    return res.data;
  } catch (error) {
    console.error("Error fetching pricing model:", error);
    throw error;
  }
};

export const updatePricingModel = async (data) => {
  try {
    const res = await api.put("/update-pricing-model", data);
    return res.data;
  } catch (error) {
    console.error("Error updating pricing model:", error);
    throw error;
  }
};

export const deletePricingModel = async (id) => {
  try {
    const res = await api.delete(`/delete-pricing-model/${id}`);
    return res.data;
  } catch (error) {
    console.error("Error deleting pricing model:", error);
    throw error;
  }
};

// Campaign CRUD API (you already had these, included for completeness)
export const createCampaign = async (data) => {
  try {
    const res = await api.post("/create-campaign", data);
    return res.data;
  } catch (error) {
    console.error("Error creating campaign:", error);
    throw error;
  }
};

export const getCampaigns = async () => {
  try {
    const res = await api.get("/campaign-list");
    return res.data;
  } catch (error) {
    console.error("Error fetching campaigns:", error);
    throw error;
  }
};

export const getCampaignById = async (id) => {
  try {
    const res = await api.get(`/view-campaign/${id}`);
    return res.data;
  } catch (error) {
    console.error("Error fetching campaign:", error);
    throw error;
  }
};

export const updateCampaign = async (id, data) => {
  try {
    const res = await api.put(`/update-campaign/${id}`, data);
    return res.data;
  } catch (error) {
    console.error("Error updating campaign:", error);
    throw error;
  }
};

export const deleteCampaign = async (id) => {
  try {
    const res = await api.delete(`/delete-campaign/${id}`);
    return res.data;
  } catch (error) {
    console.error("Error deleting campaign:", error);
    throw error;
  }
};

// Vouchers
export const downloadCouponTemplate = async (campaignId) => {
  try {
    const res = await api.post(`/download-coupon-template`, { campaignId });
    return res.data.data;
  } catch (error) {
    console.error("Error fetching vouchers by campaign:", error);
    throw error;
  }
}

export const createCoupon = async (data) => {
  try {
    const res = await api.post("/upload-coupon-file", data);
    return res.data;
  } catch (error) {
    console.error("Error creating coupon:", error);
    throw error;
  }
}

export const getCoupons = async () => {
  try {
    const res = await api.get(`/list-coupon`);
    return res.data.data;
  } catch (error) {
    console.error("Error fetching coupons:", error);
    throw error;
  }
}

export const getCouponLogs = async (couponId, couponCode) => {
  try {
    const res = await api.get(`/coupon-logs?couponCode=${couponCode}&couponId=${couponId}`);
    return res.data.data || res.data;
  } catch (error) {
    console.error("Error fetching coupon logs:", error);
    throw error;
  }
}

export const getUserCoupons = async () => {
  try {
    const res = await api.get(`/user-coupons`);
    return res.data.data || res.data;
  } catch (error) {
    console.error("Error fetching coupon logs:", error);
    throw error;
  }
}

export const createVoucher = async (data) => {
  try {
    const res = await api.post("/create-voucher", data);
    return res.data;
  } catch (error) {
    console.error("Error creating voucher:", error);
    throw error;
  }
}

export const getVouchers = async () => {
  try {
    const res = await api.get("/get-all-vouchers");
    return res.data;
  } catch (error) {
    console.error("Error fetching vouchers:", error);
    throw error;
  }
};

export const getActiveVouchers = async () => {
  try {
    const res = await api.get("/get-active-vouchers");
    return res.data;
  } catch (error) {
    console.error("Error fetching active vouchers:", error);
    throw error;
  }
}

export const getVoucherById = async (id) => {
  try {
    const res = await api.get(`/get-voucher?id=${id}`);
    return res.data;
  } catch (error) {
    console.error("Error fetching voucher:", error);
    throw error;
  }
};

export const updateVoucher = async (data) => {
  try {
    const res = await api.put(`/update-voucher`, data);
    return res.data;
  } catch (error) {
    console.error("Error updating voucher:", error);
    throw error;
  }
};

export const deleteVoucher = async (id) => {
  try {
    const res = await api.delete(`/delete-coupon/${id}`);
    return res.data;
  } catch (error) {
    console.error("Error deleting voucher:", error);
    throw error;
  }
}

export const getCampaignImpact = async (id) => {
  try {
    const res = await api.get(`/campaign-impact/${id}`);
    return res.data.data;
  } catch (error) {
    console.error("Error fetching campaign impact:", error);
    throw error;
  }
}

// Plant Trees Certificate Upload API
export const uploadPlantationCertificate = async ({ userId, campaignId, certificate }) => {
  try {
    const formData = new FormData();
    formData.append('userId', userId);
    formData.append('campaignId', campaignId);
    if (certificate) formData.append('certificate', certificate);
    const response = await api.post('/plantation-certificate', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Manual batch process triggers
export const runPullApi = async (campaignId) => {
  try {
    const res = await api.post(`/run-pull-api/${campaignId}`);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const freeExpiredCoupons = async (campaignId, maxAgeMinutes) => {
  try {
    const res = await api.post(`/free-expired-coupons/${campaignId}${maxAgeMinutes ? `?maxAgeMinutes=${maxAgeMinutes}` : ''}`);
    return res.data;
  } catch (error) {
    throw error;
  }
};